/**
 * Darstellungsmodus (hell / dunkel) der Applikation.
 *
 * Bootstrap 5.3 bringt den Dunkelmodus selbst mit: data-bs-theme="dark" am <html>
 * schaltet saemtliche Bootstrap-Komponenten um. Eigenes CSS braucht es nur noch fuer
 * das, was Bootstrap nicht kennt - siehe theme-dark.css.
 *
 * Der gewaehlte Modus liegt im Redux-State (appNavigation) und wird damit nur dann
 * gespeichert, wenn der Anwender "Daten lokal im Browser speichern" eingeschaltet hat.
 * Auf einem oeffentlichen Rechner faellt er beim naechsten Besuch auf "Automatisch"
 * zurueck - das ist gewollt: dort soll die Applikation nichts hinterlassen, auch keine
 * Kleinigkeit. "Automatisch" folgt ohnehin dem Betriebssystem.
 */

export const DISPLAY_MODE_AUTO = 'auto';
export const DISPLAY_MODE_LIGHT = 'light';
export const DISPLAY_MODE_DARK = 'dark';

export const DISPLAY_MODES = [
  { value: DISPLAY_MODE_AUTO, title: 'Automatisch' },
  { value: DISPLAY_MODE_LIGHT, title: 'Hell' },
  { value: DISPLAY_MODE_DARK, title: 'Dunkel' },
];

// Farben aus theme-dark.css bzw. der bestehenden index.html - fuer die Browserleiste
// auf dem Handy, damit sie nicht hell neben der dunklen Seite steht.
const THEME_COLOR_LIGHT = '#2D5474';
const THEME_COLOR_DARK = '#1E293B';

const systemAbfrage = window.matchMedia('(prefers-color-scheme: dark)');

export const systemBevorzugtDunkel = () => systemAbfrage.matches;

/**
 * Alles ausser "light" und "dark" gilt als "auto" - so faellt auch ein alter oder
 * beschaedigter Wert aus dem LocalStorage auf das Verhalten der Voreinstellung.
 */
export const istDunkelGewuenscht = (displayMode) =>
  displayMode === DISPLAY_MODE_DARK ||
  (displayMode !== DISPLAY_MODE_LIGHT && systemAbfrage.matches);

export const applyDisplayMode = (displayMode) => {
  const dunkel = istDunkelGewuenscht(displayMode);
  const root = document.documentElement;
  root.setAttribute('data-bs-theme', dunkel ? 'dark' : 'light');
  // Faerbt auch die native Bildlaufleiste und das Auswahlmenue der Formularfelder.
  root.style.colorScheme = dunkel ? 'dark' : 'light';
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', dunkel ? THEME_COLOR_DARK : THEME_COLOR_LIGHT);
  return dunkel;
};

/** Meldet Aenderungen der Systemeinstellung; liefert die Abmeldefunktion zurueck. */
export const beobachteSystemFarbschema = (callback) => {
  systemAbfrage.addEventListener('change', callback);
  return () => systemAbfrage.removeEventListener('change', callback);
};
